import { render, staticRenderFns } from "./ViolationPerQuestion.vue?vue&type=template&id=2fed780f&scoped=true&"
import script from "./ViolationPerQuestion.vue?vue&type=script&lang=js&"
export * from "./ViolationPerQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed780f",
  null
  
)

export default component.exports